var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.97 20.061 6.91 12l8.06-8.061 2.122 2.122L11.152 12l5.94 5.939-2.122 2.122Z",
    fill: "#4D4D4D"
  })));
};
export { SvgBack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTQuOTY5OSAyMC4wNjFMNi45MDk5MSAxMkwxNC45Njk5IDMuOTM4OTZMMTcuMDkxOSA2LjA2MDk2TDExLjE1MTkgMTJMMTcuMDkxOSAxNy45MzlMMTQuOTY5OSAyMC4wNjFaIiBmaWxsPSIjNEQ0RDREIi8+Cjwvc3ZnPgo=";